export default __webpack_public_path__ + "static/media/640_store01-jp-web.11887c0d.png";